var ProductFolioItemBuilderErrors = {
  general: function (errors) {
    var err = [];

    if (errors && errors.base && errors.base.length) {
      for (var i = 0, ilen = errors.base.length; i < ilen; i++) {
        err.push(errors.base[i]);
      }
    }

    if (errors && errors.rate_id && errors.rate_id.length) {
      for (var i = 0, ilen = errors.rate_id.length; i < ilen; i++) {
        err.push(I18n.t('rate') + ' ' + errors.rate_id[i]);
      }
    }

    if (errors && errors.product_id && errors.product_id.length) {
      for (var i = 0, ilen = errors.product_id.length; i < ilen; i++) {
        err.push(I18n.t('product') + ' ' + errors.product_id[i]);
      }
    }

    // if (errors.rate && errors.rate.length) {
    //   for (var i = 0, ilen = errors.rate.length; i < ilen; i++) {
    //     err.push(I18n.t('rate') + ' ' + errors.rate[i]);
    //   }
    // }

    return err;

  }

}

export default ProductFolioItemBuilderErrors